import React from 'react'
import logo from '../img/logo.png'
import react_logo from '../img/react_logo.png'
import tux_logo from '../img/linux_logo.png'
import db_logo from '../img/db_logo.png'
import cardlogo from '../img/sample-1.jpeg';
import pholio1 from '../img/sample-0.jpeg';

export const PortfolioPage = () => {
    return (
      <div className="mui-container z-depth-1">
          <h5>Portfolio</h5>
          <div className="logoblock"><img src={tux_logo} alt="Logo" id="grayscale"/><img src={db_logo} alt="Logo" id="grayscale"/><img src={logo} alt="Logo" id="grayscale"/><img src={react_logo} alt="Logo" id="grayscale"/></div>
              <div className="row">
                <div className="col s12 m6">
                  <div className="card medium">
                    <div className="card-image waves-effect waves-red">
                      <a href="https://noskiddie-land-folio1.web.app/">
                      <img className="activator" alt="Card Logo"src={pholio1} />
                      <span className="card-title">Effective Landing Page</span>
                      </a>
                    </div>
                    <div className="card-content reveral">
                      <p>Effective Landing Page with React JS</p>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6">
                <div className="card medium">
                    <div className="card-image waves-effect waves-block waves-light">
                      <img src={cardlogo} alt="Card Logo"/>
                      <span className="card-title activator">Example 2</span>
                    </div>
                    <div className="card-content">
                      <p>Landing page with React JS</p>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6">
                <div className="card medium">
                    <div className="card-image waves-effect waves-block waves-light">
                      <img src={cardlogo} alt="Card Logo"/>
                      <span className="card-title">Example 3</span>
                    </div>
                    <div className="card-content">
                      <p>Landing page with React JS</p>
                    </div>
                  </div>
                </div>
                <div className="col s12 m6">
                <div className="card medium">
                    <div className="card-image waves-effect waves-block waves-light">
                      <img src={cardlogo} alt="Card Logo"/>
                      <span className="card-title">Example 4</span>
                    </div>
                    <div className="card-content">
                      <p>Landing page with React JS</p>
                    </div>
                  </div>
                </div>
              </div>
    </div>
    )
}